export enum Relation {
  EQ = "eq",
  GTE = "gte",
  DEFAULT = "",
}

export type Hits = {
  value: number;
  relation: Relation;
};

export type Paginated<T extends Array<any>> = {
  hits: Hits;
  data: T;
  cursor: string;
};

export interface PaginationFilters {
  pageSize?: number;
  cursor?: string;
}
